import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { finalize } from 'rxjs';

import { BarHttpParams } from '@lvflanders/bar-ng';

import { BaasLayoutService } from './baas-layout/baas-layout.service';
import { _BarInternalLayoutService } from './bar-internal-layout.service';
import { BarLayoutService } from './bar-layout/bar-layout.service';
import { BarLayoutHttpParams } from './bar-layout-http-params';

let loadingCount = 0;
/**
 * Internal http interceptor to trap requests and show the loading indication.
 */
export function barLayoutInterceptor(options: { logging: boolean } = { logging: false }): HttpInterceptorFn {
    return (req, next) => {
        function log(message: string) {
            if (!options?.logging) return;
            console.log(`[barLayoutInterceptor] ${req.url} - count: ${loadingCount} - ${message}`);
        }
        function setLoading(loading: boolean) {
            log(`Setting loading to ${loading}`);
            layoutLegacy.loading$.next(loading);
            layout.loading.set(loading);
        }

        function handleResponse() {
            log('Handling response, decreasing counter');
            loadingCount--;
            log('Handling response, counter decreased');
            if (loadingCount == 0) {
                log('Handling response, counter zero, setting loading to false');
                setLoading(false);
            }
        }

        const layoutLegacy = inject(BarLayoutService);
        const layout = inject(BaasLayoutService);
        const internalLegacyLayout = inject(_BarInternalLayoutService);

        // if no interceptor behavior needed at global module level: just handle the request
        if ((internalLegacyLayout.legacyConsumer && !layoutLegacy.interception$.getValue()) || (!internalLegacyLayout.legacyConsumer && !layout.interception)) {
            log('Interception disabled, skipping');
            return next(req);
        }

        // by default everything is not a background request and is blocking
        let backgroundRequest = false;
        let ommitInterceptor = false;
        let blocking = true;
        // check if we have custom bar params
        if (req.params instanceof BarHttpParams) {
            backgroundRequest = (req.params as BarHttpParams).backgroundRequest;
            ommitInterceptor = (req.params as BarHttpParams).ommitInterceptor;
        }
        if (req.params instanceof BarLayoutHttpParams) {
            blocking = (req.params as BarLayoutHttpParams).blocking;
        }

        if (backgroundRequest || !blocking || ommitInterceptor) {
            log('Skipping interceptor');
            // ignore interceptor for:
            // - background requests
            // - it is non blocking call: through BarHttpParams
            // - BAR interceptors are ommitted in general
            // - the user has explicitely deifned the interception is disabled
            return next(req);
        } else {
            log('Intercepting request');
            setLoading(true);
            loadingCount++;
            log('Increasing counter');
            // https://stackoverflow.com/a/50620910/2174621
            return next(req).pipe(
                finalize(() => {
                    // request completes, errors, or is cancelled
                    handleResponse();
                })
            );
        }
    };
}
